import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaCookieBite  } from "react-icons/fa6";
import "./css/Navbar.css";

const CookieBanner  = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem("cookiePreferences");
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    const preferences = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
    setShowBanner(false);
  };

  const handleReject = () => {
    const preferences = {
      necessary: true,
      analytics: false,
      marketing: false
    };
    localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <p className="titulo bold align-center gap-10 mb-10"><FaCookieBite />Tu privacidad es importante</p>
      <p className="texto mt-10 mb-20">
        Usamos cookies para mejorar tu experiencia de navegación en la plataforma y analizar el tráfico. No recogemos información de carácter personal. <Link className="verde" to="/politica-cookies" target="_blank" rel="noopener noreferrer">Politica de Cookies</Link>
      </p>
      <div className="botones flex gap-5 mt-10">
        <button onClick={handleAccept} className="verde boton aceptar">Aceptar</button>
        <button onClick={handleReject} className="verde boton">Rechazar</button>
      </div>
    </div>
  );
};
  
export default CookieBanner ;